import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { Button as MuiButton } from "@material-ui/core";

import useStyles from "assets/jss/material-dashboard-react/components/customButtonStyle";

const Button = (props) => {
  const classes = useStyles();
  // eslint-disable-next-line react/prop-types
  const { children, color, className, disabled, ...rest } = props;

  return (
    <MuiButton
      className={clsx(classes.root, {
        [className]: className,
        [classes.disabled]: disabled,
        [classes[color]]: !disabled,
      })}
      disabled={disabled}
      {...rest}
    >
      {children || "Button"}
    </MuiButton>
  );
};

Button.propTypes = {
  children: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Button;
